module.exports = __webpack_public_path__ + "static/assets/5ece5e60fab6621fbd5b362fee63bdf6.svg";